export default __webpack_public_path__ + "static/media/imagecutout.c2526227.txt";